<div class="section">
  <div fxLayout="column" class="why" fxLayoutAlign="center center">
    <div fxLayout="column" class="container">
      <h2>Why choose ReSupply?</h2>
      <p>
        ReSupply is committed to putting your needs first as we know how important your donations are. Here is why so many charities partner
        with us to provide donation pickups.
      </p>
    </div>
  </div>
  <div fxLayout="column" class="we" fxLayoutAlign="center center">
    <div fxLayout="column" class="container">
      <div fxLayout="row wrap" fxFlex="100" fxLayoutGap="10px" fxLayoutGap.lt-lg="48px">
        <div fxLayout="column" fxFlex="25" fxFlex.sm="50" fxFlex.xs="100" fxLayoutAlign="start center">
          <div class="icon-wrapper" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon svgIcon="ss3-truck" />
          </div>
          <h3>
            We pick up
            <span>everything</span>
          </h3>
          <p>
            We pick up all items of
            <b>any</b>
            condition to find them a new home.
          </p>
        </div>
        <div fxLayout="column" fxFlex="25" fxFlex.sm="50" fxFlex.xs="100" fxLayoutAlign="start center">
          <div class="icon-wrapper" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon svgIcon="ss3-stairs" />
          </div>
          <h3>
            We remove items from
            <span>anywhere</span>
            in your home
          </h3>
          <p>Our licensed and insured haulers can pick up your items anywhere within your residence, including up and down stairs.</p>
        </div>
        <div fxLayout="column" fxFlex="25" fxFlex.sm="50" fxFlex.xs="100" fxLayoutAlign="start center">
          <div class="icon-wrapper" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon svgIcon="ss3-wrench" />
          </div>
          <h3>
            We offer Professional
            <span>Disassembly</span>
          </h3>
          <p>Our haulers are equipped with the training and tools to disassemble any of your items for removal.</p>
        </div>
        <div fxLayout="column" fxFlex="25" fxFlex.sm="50" fxFlex.xs="100" fxLayoutAlign="start center">
          <div class="icon-wrapper" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon svgIcon="ss3-dollar" />
          </div>
          <h3>
            A fee helps us
            <span>support</span>
            local charities
          </h3>
          <p>
            Our paid service provides a convenient, affordable solution with flexible scheduling, professional haulers, and full support
            throughout your pickup.
          </p>
        </div>
      </div>
      <div class="buttons" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <button
          fxFlex
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxLayoutGap="10px"
          class="primary"
          (click)="goToPrimary(sectionType)"
        >
          <span fxFlex="100">Continue to donation{{ !isSmallWindowSize ? ' pickup' : '' }}</span>
          <mat-icon svgIcon="ss3-arrow-right" />
        </button>
        <button fxFlex fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" (click)="showVideo(sectionType)">
          <span fxFlex>About ReSupply</span>
          <mat-icon svgIcon="ss3-play"></mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
